import React from 'react'
import PropTypes from 'prop-types'

import { LAYOUT_CONTAIN } from 'src/comps/Image/constants'
import Image from 'src/comps/Image'

import styles from './styles.module.css'
import {
  PAYMENT_METHOD_LOGO_WIDTH,
  PAYMENT_METHOD_LOGO_HEIGHT,
  VALID_PAYMENT_METHOD_IDS,
  PAYMENT_METHOD_LOGO_SRC_MAPPER,
} from './constants'

const PaymentMethodLogo = ({
  id,
  withoutBorder = false,
  width = PAYMENT_METHOD_LOGO_WIDTH,
  height = PAYMENT_METHOD_LOGO_HEIGHT,
}) => {
  return (
    <div
      className={`${!withoutBorder && styles.logoWithBorder} ${styles.logo}`}
      data-testid={`${id}-logo`}
    >
      <Image
        src={PAYMENT_METHOD_LOGO_SRC_MAPPER[id]}
        alt={`${id}-logo`}
        width={width}
        height={height}
        layout={LAYOUT_CONTAIN}
      />
    </div>
  )
}

PaymentMethodLogo.propTypes = {
  id: PropTypes.oneOf(VALID_PAYMENT_METHOD_IDS),
  withoutBorder: PropTypes.bool,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default PaymentMethodLogo
